<ngb-datepicker
  #dp
  class="border-0"
  [ngClass]="pickerClass"
  (dateSelect)="onDateSelection($event)"
  [displayMonths]="displayMonths"
  [dayTemplate]="dayTemplate"
  [footerTemplate]="footer"
  [minDate]="minDate | toNGBDate"
  [maxDate]="maxDate | toNGBDate"
  [startDate]="startDate | toNGBDate"
  navigation="none"
>
  <ng-template ngbDatepickerContent>
    <div class="pb-3">
      @if (dp.state.firstDate; as firstMonth) {
      <div>
        <atx-date-picker-navigation
          (previous)="navigate(-1)"
          (next)="navigate(1)"
          (titleClick)="toggleCalendar()"
        >
          {{
            firstMonth.year + '-' + firstMonth.month + '-' + 1
              | date: 'MMM yyyy'
          }}
        </atx-date-picker-navigation>
        <atx-month-picker
          [class.d-none]="!hideCalendar"
          [minDate]="minDate"
          [maxDate]="maxDate"
          [month]="firstMonth.month"
          [year]="firstMonth.year"
          (monthSelect)="monthSelected($event)"
        ></atx-month-picker>
      </div>
      }
      <div [class.months]="displayMonths > 1" [class.d-none]="hideCalendar">
        @for (month of dp.state.months; track month) {
        <div>
          @if (displayMonths > 1) {
          <div class="px-1">
            {{ month.year + '-' + month.month + '-' + 1 | date: 'MMM yyyy' }}
          </div>
          }
          <ngb-datepicker-month [month]="month"></ngb-datepicker-month>
        </div>
        }
      </div>
    </div>
  </ng-template>
</ngb-datepicker>

<ng-template
  #dayTemplate
  let-date
  let-focused="focused"
  let-currentMonth="currentMonth"
  let-disabled="disabled"
>
  <div
    class="day-wrapper"
    [class.text-muted]="date.month !== currentMonth"
    [class.outside]="date.month !== currentMonth"
    [class.range]="isRange(date)"
    [class.from]="isFromDate(date)"
    [class.to]="isToDate(date)"
    [class.disabled]="isDisabledCb(date)"
    [class.in-range]="isInRange(date)"
    [class.to-preselected]="isToPreselect(date)"
    (mouseenter)="hoveredDate = date"
    (mouseleave)="hoveredDate = null"
  >
    <span
      [attr.data-e2e]="'day-value-' + date.day"
      class="day rounded-circle"
      >{{ date.day }}</span
    >
  </div>
</ng-template>

<ng-template #footer>
  @if (displayFooterHandlers && !hideCalendar) {
  <div class="d-flex flex-row justify-content-between px-4 pb-3">
    <button
      class="btn btn-light"
      [disabled]="!fromDate"
      (click)="resetRangeSelection()"
    >
      @if (!useResetText) {
      <ng-container
        i18n="DateRange|Footer calendar cancel button@@cancelCalendarFooterBt"
      >
        Cancel
      </ng-container>
      } @else {
      <ng-container
        i18n="DateRange|Footer calendar reset button@@resetCalendarFooterBt"
      >
        Reset
      </ng-container>
      }
    </button>
    <button
      i18n="DateRange|Footer calendar select button@@selectCalendarFooterBtn"
      class="btn btn-primary"
      data-e2e="select-date-btn"
      [disabled]="!fromDate"
      (click)="onSelect()"
    >
      Select
    </button>
  </div>
  }
</ng-template>
